@if(_creditData && _infoBorrower && userDocs && _secondaryReason) {
<div class="dni_container">
  <div class="title_financing-code">
    <h1>{{financingCode}}</h1>
    @if(disableChangeStatus) {
    <button class="button-back" routerLink="/afiliado">
      <img src="../../../../assets/svg/back-arrow.svg" alt="">
      <p>Volver a la home</p>
    </button>
    }
  </div>
  @if(showAlert) {
  <app-toolbar-alerts [alertMessage]="alertMessage" [status]="alertStatus"></app-toolbar-alerts>
  }
  @for (item of docsFiltered; track $index) {
  <div>
    @if(item.alertMessage) {
    <app-toolbar-alerts [alertMessage]="item.alertMessage" [status]="'ko'"></app-toolbar-alerts>
    }

  </div>
  }

  <h2 class="affiliate-title">Adjunta los siguientes documentos:</h2>
  <div class="dni_contain">
   <!--  <div class="dni_form">
      <div>   -->
        @for (item of expansionPanels; track $index) {
        @if(item.active) {
        <div>
          @if(item.uploaded) {
          <mat-expansion-panel disabled class="expansion-panel">
            <mat-expansion-panel-header class="force-mat-content">
              <mat-panel-title>
                <mat-icon class="check-icon">check</mat-icon>
              </mat-panel-title>
              <mat-panel-description class="title-panel-expansion">
                <span class="doc-upload">DOCUMENTO SUBIDO</span>
              </mat-panel-description>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
          }
          @else if(!item.uploaded && item.active) {
          <mat-expansion-panel class="expansion-panel" hideToggle>
            <mat-expansion-panel-header class="force-mat-content">
              <mat-panel-title>
                <mat-icon>camera_enhance</mat-icon>
              </mat-panel-title>
              <mat-panel-description class="title-panel-expansion">
                {{item.title}}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="upload_box">
              <div class="methods-payment-contain">
                <div class="button-container">
                  <app-upload-files (uploadedEvent)="checkPanels($event)" (file)="receiveFile($event)"
                    [nameElement]="item.type" [buttonText]="'HACER FOTO/ SELECCIONAR'" [creditId]="idParam">
                  </app-upload-files>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
          }
        </div>
        }

    
      }  
    </div>
    </div>
<!--   </div>
</div> -->
}
<!-- <div class="revision_container" *ngIf="nextStep">
  <h4 class="modal-title">Tu financiación está aprobada</h4>
  <div class="revision_contain">
    <p class="revision_title">Verificación de documentos</p>
    <p class="revision_text">Estamos revisando tus documentos. Tardaremos como máximo 24 horas laborables.</p>
    <div class="revision_elements">
      <div class="revision_document" *ngFor="let item of expansionPanels">
        <div *ngIf="item.upload">
          <div class="document_title">
            <p>{{item.title}}</p>
            <span>En revisión</span>
          </div>
          <p class="document_text">En estos momentos estamos revisando el documento. Te avisaremos cuando terminemos.
          </p>
        </div>
      </div>
    </div>
  </div>
</div> -->